// Keep this local mapping aligned with Kasina.Utilities.Constants.PermissionCodebook.
// Version-1 codes are fixed: never rename, reassign, or reuse existing codes.
export const permissionCodebookVersion = '1';
export const permissionByCode: Readonly<Record<string, string>> = Object.freeze({
    "AM": "Application & Modules",
    "CCLI": "Client - Client Leave Incentives",
    "CIR": "Change Information Request",
    "CP": "Company Profile",
    "CSER": "Change Schedule Employee's Request",
    "D": "Dashboard",
    "DR": "Daily Report",
    "DTR": "Daily Time Record",
    "DTRPR": "DTR & Payroll Report",
    "DTRR": "DTR Report",
    "ECIR": "Employee - Change Information Request",
    "ECOE": "Employee - COE",
    "ECSR": "Employee - Change Schedule Request",
    "EDTRR": "Employee - DTR Report",
    "EH": "Employee - Holidays",
    "EHWR": "Employee - Holiday Work Request",
    "EI": "Employee Info",
    "ELA": "Employee Leave Adjustments",
    "ELR": "Employee - Leave Request",
    "EMP": "Employees",
    "EOBR": "Employee - Official Business Request",
    "EOFR": "Employee - Offset Request",
    "EOTR": "Employee - Overtime Request",
    "EP": "Employee - Payslips",
    "ERS": "Employee - Roster Schedule",
    "ES": "Employee - Schedule",
    "ETAR": "Employee - Time Adjustment Request",
    "ETRR": "Employee - Time Record Request",
    "EUR": "Employee - Undertime Request",
    "EVT": "Events",
    "HRCSR": "HR - Change Schedule Request",
    "HRH": "HR - Holidays",
    "HRHWR": "HR - Holiday Work Request",
    "HRLR": "HR - Leave Request",
    "HROBR": "HR - Official Business Request",
    "HROFR": "HR - Offset Request",
    "HROTR": "HR - Overtime Request",
    "HRS": "HR - Schedules",
    "HRSSR": "HR - Shift Schedule Request",
    "HRTAR": "HR - Time Adjustment Request",
    "HRTRR": "HR - Time Record Request",
    "HRUR": "HR - Undertime Request",
    "HWER": "Holiday Work Employee's Request",
    "IA": "Ip Addresses",
    "JC": "Job Compensation",
    "KAIGPT": "Kasina AI GPT",
    "LB": "Leave Balance",
    "LBR": "Leave Balance Report",
    "LC": "Leave Consolidation",
    "LENR": "Leave Encashment Report",
    "LER": "Leave Employee's Request",
    "N": "Newsfeed",
    "OBER": "Official Business Employee's Request",
    "OFER": "Offset Employee's Request",
    "OTER": "Overtime Employee's Request",
    "PAE": "Payroll - Adjustment Entries",
    "PAPP": "Payroll - Archive Payroll Period",
    "PBI": "Payroll - Bank Information",
    "PCNR": "Payroll - Credit Notes Report",
    "PD": "Payroll - Dashboard",
    "PDE": "Payroll - Deduction Entries",
    "PE": "Payroll - Employees",
    "PEE": "Payroll - Excluded Employees",
    "PFD": "Payroll - Fixed Deductions",
    "PFE": "Payroll - Fixed Earnings",
    "PITR": "Payroll - ITR",
    "PLK": "Payroll Lock",
    "PLN": "Payroll - Loan",
    "PLR": "Payroll - Leave Request",
    "POR": "Payroll - Overtime Requests",
    "PPP": "Payroll - Payroll Process",
    "PSAT": "Payroll - Settings - Adjustment Table",
    "PSB": "Payroll - Settings - Benefits",
    "PSD": "Payroll - Settings - Deductions",
    "PSFCF": "Payroll - Settings - Factor Computation Formula",
    "PSPHDT": "Payroll - Settings - PhilHealth Deduction Table",
    "PSPP": "Payroll - Setup Payroll Period",
    "PSSDT": "Payroll - Settings - SSS Deduction Table",
    "PSWTT": "Payroll - Settings - Withholding Tax Table",
    "PTRR": "Payroll - Time Record Requests",
    "PUR": "Payroll - Undertime Requests",
    "R": "Roles",
    "RS": "Roster Schedule",
    "SB": "Settings - Benefits",
    "SCCR": "Settings - Change Compensation Reason",
    "SCL": "Settings - Clients",
    "SCS": "Settings - Civil Status",
    "SCU": "Settings - Currency",
    "SD": "Settings - Department",
    "SEDT": "Settings - Education Type",
    "SEMT": "Settings - Email Template",
    "SESET": "Settings - Employee Status Email Template",
    "SG": "Settings - Gender",
    "SI": "Settings - Industries",
    "SJT": "Settings - Job Title",
    "SL": "Settings - Location",
    "SLT": "Settings - Leave Type",
    "SNA": "Settings - Nationality",
    "SNO": "Settings - Notification",
    "SP": "Settings - Paytype",
    "SPC": "Settings - Payroll Cutoff",
    "SRD": "Settings - Required Document",
    "SSER": "Shift Schedule Employee's Request",
    "STRL": "Settings - Time Record Logs",
    "TAER": "Time Adjustment Employee's Request",
    "TM": "Team Members",
    "TMRS": "Team Member's Roster Schedule",
    "TRER": "Time Record Employee's Request",
    "UER": "Undertime Employee's Request",
    "UL": "User Log",
    "UR": "User Roles",
    "VHD": "VisitorHub - Dashboard",
    "VHSVRT": "VisitorHub - Settings - Visit Request Types",
    "VHSVT": "VisitorHub - Settings - Visitor Types",
    "W": "Workspace"
});

const hasOwn = Object.prototype.hasOwnProperty;
const permissionFields = new Set(['permissions', 'pv', 'p']);

function hasDuplicatePermissionFields(json: string): boolean {
    const seen = new Set();
    let depth = 0;
    for (let index = 0; index < json.length; index++) {
        const character = json[index];
        if (character === '"') {
            const start = index++;
            for (; index < json.length; index++) {
                if (json[index] === '\\') index++;
                else if (json[index] === '"') break;
            }
            let next = index + 1;
            while (/\s/.test(json[next] || '') && next < json.length) next++;
            if (depth === 1 && json[next] === ':') {
                const key = JSON.parse(json.slice(start, index + 1));
                if (permissionFields.has(key)) {
                    if (seen.has(key)) return true;
                    seen.add(key);
                }
            }
        } else if (character === '{' || character === '[') depth++;
        else if (character === '}' || character === ']') depth--;
    }
    return false;
}

export function readJwtPayload(token: string | null | undefined): Record<string, unknown> | null {
    if (typeof token !== 'string' || token.split('.').length !== 3) return null;
    try {
        const encoded = token.split('.')[1];
        if (!encoded || !/^[A-Za-z0-9_-]+$/.test(encoded)) return null;
        const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
        const binary = atob(base64 + '='.repeat((4 - base64.length % 4) % 4));
        const json = decodeURIComponent(Array.from(binary, character =>
            '%' + character.charCodeAt(0).toString(16).padStart(2, '0')).join(''));
        const payload: unknown = JSON.parse(json);
        if (!payload || typeof payload !== 'object' || Array.isArray(payload) || hasDuplicatePermissionFields(json)) return null;
        return payload as Record<string, unknown>;
    } catch {
        return null;
    }
}

function readStrings(claim: unknown): string[] | null {
    if (typeof claim === 'string') return [claim];
    if (Array.isArray(claim) && claim.every(value => typeof value === 'string')) return [...claim];
    return null;
}

export function readPermissionClaims(payload: Record<string, unknown> | null): string[] {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return [];
    const permissions = hasOwn.call(payload, 'permissions') ? readStrings(payload.permissions) : [];
    if (permissions === null) return [];
    const hasVersion = hasOwn.call(payload, 'pv');
    const hasCodes = hasOwn.call(payload, 'p');
    if (hasVersion || hasCodes) {
        if (!hasVersion || !hasCodes || payload.pv !== permissionCodebookVersion) return [];
        const codes = readStrings(payload.p);
        if (codes === null || codes.some(code => !hasOwn.call(permissionByCode, code))) return [];
        permissions.push(...codes.map(code => permissionByCode[code]));
    }
    return [...new Set(permissions)];
}

export function getTokenPermissions(token: string | null | undefined): string[] {
    return readPermissionClaims(readJwtPayload(token));
}
